import React, { useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Assignment, Visibility } from '@material-ui/icons';

//tabla y card components
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import SaleProductDetail from './Detail';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import { wsFindBy } from 'services/WService';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'Fecha', accessor: 'sale_date', width: 100 },
  { Header: 'Zona', accessor: 'base_zone_description', width: 150 },
  { Header: 'Cód. Producto', accessor: 'ItemCode', width: 130 },
  { Header: 'Nombre producto', accessor: 'ItemName' },
  { Header: 'Cód. Cliente', accessor: 'CardCode', width: 120 },
  { Header: 'Nombre cliente', accessor: 'CardName' },
  { Header: '#Ventas', accessor: 'ordenes', width: 100, align: 'center' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function SaleProduct(props) {
  const classes = useStyles();

  const [saleProducts, setSaleProducts] = useState([]);
  const [open, setOpen] = useState(false);
  const [product, setProduct] = useState({ idProduct: null });
  const [dataLoading, setDataLoading] = useState(false);

  async function listSaleProducts(filter) {
    setDataLoading(true);
    let response = await wsFindBy('sale/product-consolidate', filter);
    setDataLoading(false);
    if (response.success) setSaleProducts(response.data);
  }

  return (
    <>
      {open ? (
        <ModalFull title="Detalles" open={open} setOpen={setOpen}>
          <SaleProductDetail product={product} />
        </ModalFull>
      ) : undefined}

      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment style={{ color: 'white' }} />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado de productos vendidos{dataLoading && <LoadingSpinner />}</h4>
        </CardHeader>
        <CardBody>
          <FilterCustom 
            getFilter={listSaleProducts}
            dateRange
            diffRange={0}
            dateField="sale_date"
            provider
            zone 
          />
          <ReactTable
            excelName="Marcas"
            defaultWidth={1200}
            formatDate="DD-MM-YYYY"
            columns={columns}
            data={saleProducts.map((item, i) => {
              // TODO ? modificar permiso
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <AllowedGuard permission={ConstantPermissions.SALE_ORDERS_SHOW}>
                      <Button
                        justIcon
                        round
                        simple
                        color={props.themeContext.buttonColor}
                        onClick={() => {
                          setOpen(true);
                          setProduct({ ...item, idProduct: item.logi_product_id });
                        }}
                      >
                        <Visibility />
                      </Button>
                    </AllowedGuard>
                  </div>
                ),
                sale_date: item.sale_date,
                base_zone_description: `${item.base_zone_code} - ${item.base_zone_description}`,
                ItemCode: item.ItemCode,
                ItemName: item.ItemName,
                CardCode: item.CardCode,
                CardName: item.CardName,
                ordenes: item.ordenes,
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
